module.exports = __webpack_public_path__ + "img/red-white--royal-blue.ebe54a49.png";